// ui/atoms/Textarea.tsx
import styled from "styled-components";

export const Textarea = styled.textarea`
  min-height: 120px;
  padding: 10px;
  border-radius: ${({ theme }) => theme.radius.sm};
  border: 1px solid ${({ theme }) => theme.colors.border};
  resize: vertical;
`;